import { render } from "./Pdf.vue?vue&type=template&id=3f7fc431&scoped=true"
import script from "./Pdf.vue?vue&type=script&lang=js"
export * from "./Pdf.vue?vue&type=script&lang=js"

import "./Pdf.vue?vue&type=style&index=0&id=3f7fc431&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3f7fc431"

export default script